import React from "react";
import { Card, CardContent } from "@mui/material";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

const card = { border: "1px solid #dfe4e1", borderRadius: 16, boxShadow: "none" };
const number = value => Number(value || 0).toLocaleString("pt-BR", { maximumFractionDigits: 1 });
const money = value => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

function Metric({ label, value, warning }) {
  return <Card style={card}><CardContent><small style={{ color: "#718078", letterSpacing: ".12em" }}>{label.toUpperCase()}</small>
    <div style={{ color: warning ? "#b7251f" : "#0b6d4a", fontSize: 27, fontWeight: 800, marginTop: 7 }}>{value}</div>
  </CardContent></Card>;
}

export default function TrackingDashboard({ data = {} }) {
  return <div style={{ display: "grid", gap: 10 }}>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 10 }}>
      <Metric label="Total de leads" value={number(data.total)} />
      <Metric label="Leads rastreados" value={number(data.tracked)} />
      <Metric label="Cobertura de rastreio" value={`${number(data.coverage)}%`} warning={data.coverage < 50} />
      <Metric label="Sem atribuição" value={number(data.unattributed)} warning={data.unattributed > 0} />
      <Metric label="Conversões atribuídas" value={number(data.conversions)} />
    </div>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))", gap: 10 }}>
      <Card style={card}><CardContent><h2 style={{ fontSize: 16, marginTop: 0 }}>Leads rastreados por dia</h2>
        <div style={{ width: "100%", height: 250 }}><ResponsiveContainer><LineChart data={data.daily || []}>
          <CartesianGrid strokeDasharray="2 4"/><XAxis dataKey="date" tick={{fontSize:9}}/><YAxis tick={{fontSize:9}}/>
          <Tooltip/><Line dataKey="leads" stroke="#afbdcc" strokeWidth={2} dot={false}/>
          <Line dataKey="tracked" stroke="#078b59" strokeWidth={2} dot={false}/>
        </LineChart></ResponsiveContainer></div>
      </CardContent></Card>
      <Card style={card}><CardContent><h2 style={{ fontSize: 16, marginTop: 0 }}>Origem</h2>
        {data.sources?.length ? data.sources.map(source => <div key={source.source} style={{ borderTop: "1px solid #e9edea", padding: "9px 0" }}>
          <strong>{source.source}</strong><small style={{ display: "block", color: "#77847d" }}>
            {source.leads} leads · {source.conversions} conversões · {money(source.revenue)}
          </small></div>) : <p>Nenhuma origem rastreada no período.</p>}
      </CardContent></Card>
    </div>
    {data.unattributed > 0 && <div style={{ borderRadius: 12, padding: 12, background: "#fff7ed", border: "1px solid #ffddad", color: "#9b5b0b" }}>
      {number(data.unattributed)} leads sem origem. Configure UTMs e identifique as campanhas de entrada.
    </div>}
  </div>;
}
